import { Typography } from '@mui/material';
import type { InvoiceOverview } from '@vy/api-definition';
import React from 'react';
import { VyTooltip } from '../../../../../../components/new-design/VyTooltip/VyTooltip';
import { isNotEmptyString } from '@vy/string';
import { whenDefined } from '@vy/null';
import { formatNumber } from '@vy/number';

type MarketplaceUnitsCellProps = {
  row: InvoiceOverview;
};

export const MarketplaceUnitsCell: React.FC<MarketplaceUnitsCellProps> = ({ row }) => {
  const marketplaceUnits = row.marketplaceUnits;

  if (!marketplaceUnits) {
    return <span>—</span>;
  }

  const stringifiedDimensions = marketplaceUnits.dimensions?.map((entry) => `${entry.dimension}: ${formatNumber(entry.quantity)}`);
  const concatenatedDimensions = whenDefined(stringifiedDimensions, (dimensions) => dimensions.join(', '));
  const hasTooltipContent = isNotEmptyString(concatenatedDimensions);

  return (
    <VyTooltip
      placement="top"
      tooltipContent={
        hasTooltipContent ? <span style={{ whiteSpace: 'pre-line' }}>{concatenatedDimensions}</span> : undefined
      }
    >
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {formatNumber(marketplaceUnits.total)}
      </Typography>
    </VyTooltip>
  );
};
